import api from "./axios";
import type { Completion } from "../types";

interface CreateCompletionData {
  camperId: number;
  achievementCreditId: number;
  status: string;
  completedDate?: string;
  notes?: string;
}

export const completionsApi = {
  list: async (params?: { cabinGroupId?: number; camperId?: number; year?: number }): Promise<Completion[]> => {
    const res = await api.get<Completion[]>("/completions", { params });
    return res.data;
  },

  create: async (data: CreateCompletionData): Promise<Completion> => {
    const res = await api.post<Completion>("/completions", data);
    return res.data;
  },

  bulkCreate: async (completions: CreateCompletionData[]): Promise<Completion[]> => {
    const res = await api.post<Completion[]>("/completions/bulk", { completions });
    return res.data;
  },

  update: async (id: number, data: Partial<CreateCompletionData>): Promise<Completion> => {
    const res = await api.put<Completion>(`/completions/${id}`, data);
    return res.data;
  },

  uploadArtifact: async (id: number, file: File): Promise<Completion> => {
    const form = new FormData();
    form.append("artifact", file);
    const res = await api.post<Completion>(`/completions/${id}/artifact`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },
};
